import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { withTheme } from 'theming';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import ActionButton from '../ActionButton';
import MarkdownText from '../MarkdownText';
import styles from './styles';
var useStyles = createUseStyles(styles);
var Feedback = function Feedback(props) {
  var classesProp = props.classes,
    className = props.className,
    text = props.text,
    actions = props.actions;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, text && /*#__PURE__*/React.createElement(MarkdownText, {
    className: classes.text,
    text: text
  }), actions && /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(ActionButton, _extends({
      key: index
    }, action));
  }))));
};
Feedback.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  text: PropTypes.objectOf(PropTypes.string),
  actions: PropTypes.arrayOf(PropTypes.shape(ActionButton.propTypes))
};
Feedback.defaultProps = {
  className: null,
  classes: {},
  text: '',
  actions: null
};
export default withMemo()(withTheme(Feedback));